import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledTopCompaniesStateWrapper = styled(Stack)`
    position: relative;
    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
`;

export const StyledTopCompaniesEmptyState = styled(StyledTopCompaniesStateWrapper)`
    padding: 32px 8px;
`;

export const StyledTopCompanyEmptyIcon = styled(SWReactIcons)`
    width: 133px;
    height: 95px;

    svg {
        width: 133px;
        height: 95px;
    }
`;
